import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { calculateRem } from '@vds/utilities';
import { TextLink as CoreTextLink } from '@vds-core/buttons';
import { ColorTokens } from '@vds-tokens/color';
import { TypographyTokens } from '@vds-tokens/typography';
var propTypes = {
  /**
   * Option to render on dark or light surface
   */
  surface: PropTypes.oneOf(['light', 'dark'])
};
var defaultProps = {
  surface: 'light'
};
var _calculateColors = function _calculateColors(surface) {
  return {
    "default": surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value,
    hover: surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value,
    active: surface === 'dark' ? ColorTokens.interactive.active.ondark.value : ColorTokens.interactive.active.onlight.value,
    disabled: surface === 'dark' ? ColorTokens.interactive.disabled.ondark.value : ColorTokens.interactive.disabled.onlight.value
  };
};
var _calculateUnderLine = function _calculateUnderLine(calculateColors, surface) {
  var color = calculateColors(surface);
  return {
    "default": "".concat(calculateRem(1), " solid ").concat(color["default"]),
    hover: "".concat(calculateRem(2), " solid ").concat(color.hover),
    active: "".concat(calculateRem(2), " solid ").concat(color.active),
    disabled: "".concat(calculateRem(1), " solid ").concat(color.disabled)
  };
};
var _calculateLetterSpacing = function _calculateLetterSpacing(size, viewport, bold) {
  var letterSpacing = '0px';
  if (size === 'large' && viewport === 'desktop') {
    letterSpacing = TypographyTokens.letterspacing.wide.value;
  }
  return letterSpacing;
};
var TextLink = function TextLink(props) {
  return /*#__PURE__*/React.createElement(CoreTextLink, _extends({}, props, {
    calculateColors: _calculateColors,
    calculateUnderLine: _calculateUnderLine,
    calculateLetterSpacing: _calculateLetterSpacing,
    focusRingBorderRadius: "2px",
    bold: false
  }));
};
TextLink.propTypes = propTypes;
TextLink.defaultProps = defaultProps;
export default TextLink;